import React from "react";

function useLocalStorage(itemName, initialValue) {
  // ESTADOS
  const [item, setItem] = React.useState(initialValue);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      try {
        // Guardar en el navegador el array de tareas
        const localStorageItem = localStorage.getItem(itemName);
        let parsedItem;

        if (!localStorageItem) {
          // registrar tareas 1ra vez
          localStorage.setItem(itemName, JSON.stringify(initialValue));
          parsedItem = initialValue;
        } else {
          parsedItem = JSON.parse(localStorageItem);
        }
        setLoading(false);
      } catch (error) {
        setError(true);
        console.log("🚧 catch", error);
        setLoading(false);
      }
    }, 2000);
  }, []);

  // FUNCIONES
  const saveItem = (newItem) => {
    const stringifiedItem = JSON.stringify(newItem);
    localStorage.setItem(itemName, stringifiedItem);
    setItem(newItem);
  };

  return { item, saveItem, loading, error };
}

export { useLocalStorage };
